export interface RequestError {
  response?: {
    status?: number
  }
}

export enum Language {
  PT = 'pt',
  EN = 'en',
  ES = 'es',
  FR = 'fr'
}

export enum Breakpoints {
  XS = 0,
  SM = 576,
  MD = 768,
  LG = 992,
  XL = 1200,
  XXL = 1700
}

export enum LayoutType {
  DESKTOP = 'DESKTOP',
  MOBILE = 'MOBILE'
}

export enum Orientation {
  PORTRAIT = 'PORTRAIT',
  LANDSCAPE = 'LANDSCAPE'
}

export enum Referer {
  CLUB = 'club'
}

export enum HttpCodes {
  OK = 200,
  NO_CONTENT = 204,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  NOT_ALLOWED = 405,
  UNPROCESSABLE_ENTITY = 422,
  INTERNAL_SERVER_ERROR = 500,
  GATEWAY_TIMEOUT = 504
}
